import { Alarm } from './Alarm';
import { AlertTriangle } from './AlertTriangle';
import { Arabic } from './Arabic';
import { ArrowDown } from './ArrowDown';
import { ArrowLeft } from './ArrowLeft';
import { ArrowUp } from './ArrowUp';
import { Building } from './Building';
import { Burger } from './Burger';
import { CheckBrokenCircle } from './CheckBrokenCircle';
import { CheckCircle } from './CheckCircle';
import { CheckVerified } from './CheckVerified';
import { Clock } from './Clock';
import { Close } from './Close';
import { Dot } from './Dot';
import { DotsHorizontal } from './DotsHorizontal';
import { Edit } from './Edit';
import { English } from './English';
import { HourGlass } from './HourGlass';
import { IconDef } from './types';
import { InfoCircle } from './InfoCircle';
import { Logout } from './Logout';
import { Map } from './Map';
import { Menu } from './Menu';
import { Minus } from './Minus';
import { MoonStar } from './MoonStar';
import { Order } from './Order';
import { Phone } from './Phone';
import { Pin } from './Pin';
import { Plus } from './Plus';
import { Print } from './Print';
import { Settings } from './Settings';
import { SlashCircle } from './SlashCircle';
import { Target } from './Target';
import { Trips } from './Trips';
import { User } from './User';
import { UserDown } from './UserDown';
import { XCircle } from './XCircle';

export type IconName =
  | 'logout'
  | 'burger'
  | 'building'
  | 'print'
  | 'settings'
  | 'trips'
  | 'order'
  | 'dot'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-up'
  | 'phone'
  | 'alarm'
  | 'clock'
  | 'user'
  | 'close'
  | 'menu'
  | 'ar'
  | 'en'
  | 'map'
  | 'target'
  | 'moon-star'
  | 'dots-horizontal'
  | 'check-verified'
  | 'user-down'
  | 'check-broken-circle'
  | 'slash-circle'
  | 'x-circle'
  | 'pin'
  | 'minus'
  | 'plus'
  | 'hour-glass'
  | 'alert-triangle'
  | 'check-circle'
  | 'info-circle'
  | 'edit';

export const svgs: Record<IconName, IconDef> = {
  order: Order,
  logout: Logout,
  burger: Burger,
  print: Print,
  settings: Settings,
  trips: Trips,
  dot: Dot,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-up': ArrowUp,
  phone: Phone,
  alarm: Alarm,
  clock: Clock,
  user: User,
  close: Close,
  menu: Menu,
  'moon-star': MoonStar,
  ar: Arabic,
  en: English,
  map: Map,
  building: Building,
  target: Target,
  'dots-horizontal': DotsHorizontal,
  'check-verified': CheckVerified,
  'user-down': UserDown,
  'check-broken-circle': CheckBrokenCircle,
  'slash-circle': SlashCircle,
  'x-circle': XCircle,
  pin: Pin,
  minus: Minus,
  plus: Plus,
  'hour-glass': HourGlass,
  'info-circle': InfoCircle,
  'alert-triangle': AlertTriangle,
  'check-circle': CheckCircle,
  edit: Edit,
};
